// Xử lý media: image, file, video...
import dayjs from 'dayjs'
import DomToImage from 'dom-to-image'
import FileSaver from 'file-saver'

/**
 * Hàm xử lý convert dom sang image dạng png
 */
export const handleScreenshotOrder = () => {
  DomToImage.toBlob(document.getElementById('order_code')).then(function (blob) {
    const fileName = `screenshot_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}.png`
    FileSaver.saveAs(blob, fileName)
  })
}
